import React from 'react';

function LogoCropDemo() {
  const cropOptions = [
    {
      name: "Option 1: Less Zoom (Wide View)",
      scale: 1.5,
      position: "75% center"
    },
    {
      name: "Option 2: Medium Zoom",
      scale: 2.0,
      position: "80% center"
    },
    {
      name: "Option 3: Current (More Zoom)",
      scale: 2.5,
      position: "85% center"
    },
    {
      name: "Option 4: Tight Zoom",
      scale: 3.0,
      position: "85% center"
    },
    {
      name: "Option 5: Full Right Edge",
      scale: 1.8,
      position: "90% center"
    },
    {
      name: "Option 6: Center-Right Balance",
      scale: 2.2,
      position: "78% center"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-900 py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="bg-gray-800 rounded-lg p-6 mb-8">
          <h1 className="text-3xl font-bold text-green-400 mb-2">Logo Crop Options for Progress Bar</h1>
          <p className="text-gray-300">Choose which crop of the logo works best for the progress bar icon</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {cropOptions.map((option, idx) => (
            <div key={idx} className="bg-gray-800 rounded-lg p-6 border-2 border-green-500/30">
              <h3 className="text-xl font-bold text-white mb-4">{option.name}</h3>
              
              {/* Large preview */}
              <div className="mb-4 flex justify-center">
                <div className="w-24 h-24 rounded-full overflow-hidden bg-green-500 border-4 border-green-400 shadow-xl">
                  <img 
                    src="/derose-logo.png" 
                    alt="Logo crop" 
                    className="w-full h-full object-cover"
                    style={{
                      objectPosition: option.position,
                      transform: `scale(${option.scale})`
                    }}
                  />
                </div>
              </div>

              {/* Small preview (actual size on progress bar) */}
              <div className="text-center mb-4">
                <p className="text-gray-400 text-sm mb-2">Actual Size:</p>
                <div className="inline-flex items-center justify-center">
                  <div className="w-7 h-7 rounded-full overflow-hidden bg-green-500 border-2 border-green-400 shadow-lg">
                    <img 
                      src="/derose-logo.png" 
                      alt="Logo crop" 
                      className="w-full h-full object-cover"
                      style={{
                        objectPosition: option.position,
                        transform: `scale(${option.scale})`
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Settings */}
              <div className="bg-gray-900 rounded p-3 text-xs text-gray-400 font-mono">
                <p>Scale: {option.scale}x</p>
                <p>Position: {option.position}</p>
              </div>

              {/* Simulated progress bar */}
              <div className="mt-4">
                <p className="text-gray-400 text-sm mb-2">On Progress Bar:</p>
                <div className="relative h-2 bg-gray-700 rounded-full">
                  <div className="absolute inset-0 bg-gradient-to-r from-green-500 to-green-400 rounded-full" style={{width: '60%'}}></div>
                  <div 
                    className="absolute top-1/2 -translate-y-1/2"
                    style={{ left: '60%', transform: 'translate(-50%, -50%)' }}
                  >
                    <div className="w-7 h-7 rounded-full overflow-hidden bg-green-500 border-2 border-green-400 shadow-lg">
                      <img 
                        src="/derose-logo.png" 
                        alt="Logo" 
                        className="w-full h-full object-cover"
                        style={{
                          objectPosition: option.position,
                          transform: `scale(${option.scale})`
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-gray-800 rounded-lg p-6 border-2 border-green-500/30">
          <h3 className="text-xl font-bold text-green-400 mb-3">Full Logo Reference</h3>
          <div className="flex justify-center">
            <img 
              src="/derose-logo.png" 
              alt="Full Logo" 
              className="h-32 w-auto"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default LogoCropDemo;
